import React from 'react';

interface LogoProps {
  className?: string;
  size?: number;
}

const Logo: React.FC<LogoProps> = ({ className = "", size = 48 }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="text-simios-accent"
      >
        {/* Geometric/Boxy Ape Face Construction */}
        
        {/* Outline / Jaw */}
        <path
          d="M20 30 L10 50 L25 85 L50 95 L75 85 L90 50 L80 30 L50 15 L20 30Z"
          className="stroke-current"
          strokeWidth="3"
          strokeLinejoin="round"
        />
        
        {/* Brow Ridge */}
        <path
          d="M20 30 L35 45 L65 45 L80 30"
          className="stroke-current"
          strokeWidth="3"
          strokeLinejoin="round"
        />
        
        {/* Nose / Center Snout */}
        <path
          d="M40 55 L50 45 L60 55 L60 70 L50 75 L40 70 L40 55Z"
          className="fill-current opacity-20 stroke-current"
          strokeWidth="2"
        />
        
        {/* Eyes (Sharp/Techy) */}
        <path
          d="M25 50 L35 55 L25 60Z"
          className="fill-current"
        />
        <path
          d="M75 50 L65 55 L75 60Z"
          className="fill-current"
        />
        
        {/* Tech Circuit Lines */}
        <line x1="50" y1="15" x2="50" y2="45" stroke="currentColor" strokeWidth="2" />
        <line x1="25" y1="85" x2="40" y2="70" stroke="currentColor" strokeWidth="2" />
        <line x1="75" y1="85" x2="60" y2="70" stroke="currentColor" strokeWidth="2" />

      </svg>
      <span className={`font-bold tracking-wider uppercase ${size > 40 ? 'text-2xl' : 'text-xl'}`}>
        Simios
      </span>
    </div>
  );
};

export default Logo;
